import { Card, Col } from "react-bootstrap"

export const MostCalls = () => {

    return (
        <Col lg={2}>
            <Card className="h-100 rounded-3 p-0 position-relative" style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}>
                <Card.Body className="px-3 pt-3 pb-2 mb-0 d-flex flex-column justify-content-between h-100">
                    <div className="mb-0">
                        <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px' }}>
                            Most Calls
                        </span>
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>
                            Today's top callers
                        </span>
                    </div>

                    <hr style={{ height: '0.1rem' }} />

                    <div className="d-flex flex-column align-items-center justify-content-evenly flex-grow-1 gap-1 text-center">
                        {[
                            { name: "Rahul Verma", val: "48" },
                            { name: "Priya Sharma", val: "42" },
                            { name: "Aisha Patel", val: "35" },
                            { name: "Ankit Mehta", val: "29" },
                        ].map((item, idx) => (
                            <div
                                key={idx}
                                className={`py-2 ${idx !== 0 ? 'border-top' : ''} w-100 d-flex flex-column align-items-center text-center rounded-2 px-1`}
                                style={{
                                    borderColor: "#f0f4fc",
                                    alignSelf: 'center',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <h4 className="mb-0" style={{ fontWeight: 400, letterSpacing: "-0.02em", fontSize: "2rem", color: "#0f172a" }}>
                                    {item.val}
                                </h4>

                                <span className="text-muted fw-medium text-truncate" style={{ fontSize: "12px", letterSpacing: "-0.01em", maxWidth: "90px" }}>
                                    {item.name}
                                </span>
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    )
}
